var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation-item"},[_c('div',{staticClass:"body-bold"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"body-text"},[_vm._v(_vm._s(_vm.value || "-"))]),_c('v-divider',{staticClass:"grid-span-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }